{
  "actions.logout": "Logout",
  "actions.language": "Langue",
  "actions.support_request": "Demande d'assistance",
  "actions.download": "Télécharger",
  "actions.print": "Imprimer",
  "documents.preview.cant_be_previewed": "Le fichier ne peut pas être prévisualisé.",
  "documents.preview.node_actions.pages": "{currentPage} sur {totalPages} pages",
  "errors.error_occurred": "Une erreur s'est produite",
  "actions.cancel": "Annuler",
  "actions.confirm": "Confirmer",
  "actions.delete": "Supprimer",
  "actions.save": "Sauvegarder",
  "article.new": "Nouvel article de base de connaissances",
  "article.create": "Créer un article",
  "article.edit": "Modifier l'article",
  "article.remove": "Supprimer l'article",
  "article.state.draft": "Brouillon",
  "article.state.migrated": "Migré",
  "article.state.published": "Publié",
  "article.state.delete-requested": "Demande de suppression",
  "article.state.deleted": "Supprimé",
  "article.visibility.internal": "Interne",
  "article.visibility.public": "Public",
  "folder.create": "Créer un dossier",
  "folder.delete": "Supprimer le dossier",
  "folder.delete-confirmation": "Êtes-vous sûr de vouloir supprimer ce dossier ?",
  "chat.title": "Chat",
  "chat.all": "Chat de tout",
  "chat.kb": "Chat de la base de connaissances",
  "chat.kb_attachment": "Pièce jointe KB",
  "chat.ticket": "Ticket",
  "chat.jira": "Chat de Jira",
  "title": "Titre",
  "problem": "Problème",
  "solution": "Solution",
  "application": "Application",
  "affected-versions": "Versions affectées",
  "from": "De",
  "to": "À",
  "affected-servicepack": "Pack de services",
  "environment-system": "Environnement / Système",
  "parent-element": "Élément parent",
  "visibility": "Visibilité",
  "created-by": "Créé par",
  "on": "sur",
  "recently-edited-by": "Récemment modifié par",
  "edit": "Modifier",
  "review-migrations": "Examen des migrations",
  "review": "Examen",
  "confirm-delete": "Confirmer la suppression",
  "save-for-review": "Enregistrer pour examen",
  "publish": "Publier",
  "release": "Sortie",
  "description-problem": "Description / Problème",
  "attachments": "Pièces jointes",
  "compare": "Comparer {left} - {right}",
  "all": "Tout",
  "unassigned": "Non attribué",
  "id": "ID",
  "status": "Statut",
  "last-editor": "Dernier éditeur",
  "edited-at": "Modifié à",
  "current": "Actuel",
  "previous": "Précédent",
  "editor": "Éditeur",
  "version": "Version",
  "compare-with": "Comparer avec",
  "main": "Principal",
  "versions": "Versions",
  "request-removal": "Demander la suppression",
  "yes-remove": "Oui, supprimer",
  "remove": "Supprimer",
  "retract": "Retirer",
  "search": "Rechercher ...",
  "please-specify-new-folder-name": "Veuillez spécifier le nouveau nom du dossier",
  "name": "Nom",
  "unable-to-create-new-folder-error": "Impossible de créer un nouveau dossier: {0}",
  "knowledge-base": "Knowledge Base",
  "access-denied": "Accès refusé",
  "article.article-needs-verification": "L'article sera vérifié par une autre personne après avoir été enregistré. Sélectionnez l'utilisateur souhaité.",
  "article.article-not-found": "Cet article n'a pas été trouvé.",
  "article.do-not-remove-article": "Ne pas supprimer l'article",
  "article.do-you-want-to-remove-this-article": "Voulez-vous vraiment supprimer cet article ? Cette action est irréversible.",
  "article.download-pdf": "Télécharger en PDF",
  "article.removal-requires-approval": "La suppression de l'article doit être confirmée par un réviseur. Sélectionnez l'utilisateur souhaité.",
  "article.watch-article": "Surveiller l'article",
  "article.watched": "Article surveillé",
  "article.watched-article": "Article surveillé",
  "tickets.ticket-not-found": "Le ticket n'a pas été trouvé",
  "tickets.state.draft": "Brouillon",
  "tickets.state.published": "Publié",
  "errors.check_your_inputs": "Vérifiez votre entrées",
  "assigned": "Attribué",
  "last-reviewer": "Dernier réviseur",
  "page-guard.changes-not-saved": "Voulez-vous vraiment quitter le formulaire? Les modifications effectuées ne seront pas enregistrées.",
  "page-guard.changes-not-saved-title": "Modifications non enregistrées",
  "continue": "Continuer",
  "chat.delete_all": "Supprimer toutes les chat",
  "chat.no_chats_saved": "Aucune chat enregistrée",
  "chat.documents": "Documents",
  "chat.course_material": "Supports de cours",
  "chat.release_courses": "Cours sur les nouveautés",
  "chat.misc_docs": "Autres documents",
  "chat.news": "Actualités partenaires",
  "chat.release_info": "Informations release",
  "chat.f1_hilfe": "Aide F1",
  "chat.new_chat": "Nouvelle chat",
  "article.needs_transations": "L'article a besoin de traductions",
  "languages.de": "Allemand",
  "languages.en": "Anglais",
  "languages.fr": "Français",
  "languages.it": "Italien",
  "language-not-supported": "Langue non prise en charge",
  "edit-translation": "Modifier la traduction",
  "save-translation": "Enregistrer la traduction",
  "error": "Erreur",
  "article.versions.to": "Jusqu'à",
  "article.versions.from": "À partir de",
  "servicepack": "Pack de services",
  "max-count": "{0} max.",
  "article.versions.from_to_entry": "Saisie Du / Au",
  "select-applications": "Sélectionnez les applications",
  "load-applications": "Charger les applications",
  "select-servicepack": "Sélectionnez le pack de services",
  "load-servicepacks": "Charger les packs de services",
  "select-version": "Choisir la version",
  "load-versions": "Chargement des versions",
  "chat.reply_stopped": "Cette réponse a été interrompue",
  "report": "Signaler",
  "open-source": "Ouvrir la source",
  "sources": "Sources",
  "matches": "Résultats",
  "chat.sources_empty_text": "Dès que vous posez une question, les sources apparaîtront ici.",
  "chat.empty_text": "Comment puis-je vous aider aujourd'hui?",
  "hello": "Bonjour",
  "chat.filter.collection.all": "Tout",
  "chat.prompt_placeholder": "Posez votre question",
  "send": "Envoyer",
  "chat.report_answer": "Signaler la réponse",
  "chat.your_message": "Votre message",
  "chat.diagram_loading": "Création du diagramme…",
  "chat.diagram_open": "Ouvrir le diagramme",
  "chat.diagram_filename": "diagramme.png",
  "cancel": "Annuler",
  "refresh": "Rafraîchir",
  "to-migrate": "Pour migrer",
  "not-assigned": "Non attribué",
  "to-do": "À faire",
  "article.dashboard.external_user.welcome_text": "Pour trouver l'article de base de connaissances recherché, utilisez le champ de recherche ou sélectionnez une catégorie.",
  "last-updated": "Dernière mise à jour",
  "old": "Vieux",
  "new": "Nouveau",
  "summary": "Résumé",
  "tickets.support_request": "Demande d'assistance",
  "clarifications": "Clarifications",
  "to-review": "À réviser",
  "tickets.ticket_no": "Ticket n°",
  "date": "Date",
  "tickets.needs_transations": "Le ticket a besoin de traductions",
  "users.group_search_or_select": "Rechercher ou sélectionner un groupe",
  "users.favorites": "Favoris",
  "users.all_users": "Tous les utilisateurs",
  "users.favorite_add": "Ajouter aux favoris",
  "users.favorite_remove": "Retirer des favoris",
  "users.user_search_or_select": "Rechercher ou sélectionner un utilisateur",
  "admin.title": "Administration",
  "admin.chat.reports": "Signalements de chat",
  "article.errors.save_conflict": "L’article a été modifié par un autre utilisateur entre-temps. Veuillez recharger la page et réessayer.",
  "tickets.errors.save_conflict": "Ce ticket a été modifié par un autre utilisateur entre-temps. Veuillez recharger la page et réessayer.",
  "project": "Projet",
  "article.language.alert.translation_text": "Traduction {lang} de cet article",
  "article.language.alert.english": "anglaise",
  "article.language.alert.french": "française",
  "article.language.alert.italian": "italienne",
  "article.language.alert.only_relevant_fields": "Seuls les champs pertinents pour la traduction sont affichés.",
  "article.language.show_original": "Afficher l'original (DE)",
  "article.language.original_article": "Article original (DE)",
  "admin.chat.table_headers.report": "Signalement",
  "admin.chat.table_headers.chat_filter": "Filtre de chat",
  "admin.chat.table_headers.reported_by": "Signalé par",
  "admin.chat.table_headers.reported_on": "Signalé le",
  "admin.chat.detail_title": "Détails du signalement",
  "tickets.back_to_list": "Retour à la liste",
  "tickets.show_old": "Afficher VIEUX",
  "filter": "Filtre",
  "my-employee-group": "Mon groupe d'employés",
  "preview": "Aperçu",
  "preview.previous_attachment": "Pièce jointe précédente",
  "preview.next_attachment": "Pièce jointe suivante",
  "article.restore_this_revision": "Restaurer cette version",
  "page-guard.back-to-form": "Retour au formulaire",
  "page-guard.discard-changes": "Abandonner les modifications",
  "time.just_now": "à l’instant",
  "time.yesterday_at": "hier à",
  "is-saving": "Enregistrement",
  "last-saved": "Dernière sauvegarde",
  "article.discard_my_changes": "Annuler mes modifications",
  "article.no_changes_yet": "aucun changement pour l'instant",
  "actions.close": "Fermer",
  "article.autosave.hint_not_up_to_date": "Cet article a été modifié par quelqu'un d'autre depuis. Par conséquent, vos modifications peuvent être obsolètes. Vous pouvez annuler vos modifications pour ensuite éditer la version actuelle.",
  "article.autosave.hint_saved_changes": "Vous avez enregistré des modifications pour cet article.",
  "outdated": "Obsolète",
  "article.autosave.version_status": "État",
  "article.autosave.pending_changes": "Mes modifications en cours",
  "article.autosave.load_error": "Votre progression enregistrée n'a pas pu être chargée. Voulez-vous toujours ouvrir l'article ? Votre progression enregistré pourrait être écrasé.",
  "open-anyway": "Ouvert quand même",
  "article.autosave.show_my_changes": "Afficher mes modifications",
  "article.migrated_alert": "Cet article n'a pas été révisé depuis la migration depuis l'ancienne base de connaissances.",
  "development": "Développement",
  "select-reviewer": "Sélectionner un réviseur",
  "users.select_group_text": "Sélectionnez le groupe souhaité.",
  "tickets.state.not_relevant": "Pas pertinent",
  "tickets.state.migrated": "Migré",
  "tickets.state.not_relevant_requested": "Non pertinent demandé",
  "tickets.unused_requires_approval": "Cette action doit être confirmée par un réviseur. Sélectionnez l'utilisateur souhaité.",
  "tickets.change_to_relevant": "Remplacer par pertinent",
  "tickets.confirm_not_relevant": "Confirmer non pertinent",
  "tickets.ticket_not_relevant": "Le ticket n'est pas pertinent",
  "count-selected": "{0} sélectionné",
  "assign": "Attribuer",
  "assign-group": "Attribuer un groupe",
  "group": "Groupe",
  "users.select_user_text": "Sélectionnez l'utilisateur souhaité.",
  "tickets.assign_ticket_count": "Attribuer {0} tickets",
  "tickets.assign_group_count": "Attribuer {0} tickets à un groupe",
  "chat.delete_all_msg": "Êtes-vous sûr de vouloir supprimer tous les chats?",
  "chat.deleta_all_confirm": "Oui, supprimer",
  "reject": "Rejeter",
  "folder.rename": "Renommer le dossier",
  "unable-to-rename-folder-error": "Impossible de renommer le dossier : {0}",
  "move": "Déplacer",
  "yes-move": "Oui, déplacer",
  "tree.really_move": "Êtes-vous sûr de vouloir déplacer <b>{0}</b> vers <b>{1}</b> ?",
  "tree.folder_to_kb_warning": "Un répertoire ne peut pas être déplacé vers une KB.",
  "tree.really_move_to_root": "Voulez-vous vraiment passer <b>{0}</b> au <b>niveau supérieur</b>?",
  "tree.hint_search_result": "{0} sur {1} résultats",
  "nothing-found": "Aucun résultat trouvé",
  "tickets.keep_original": "Acceptez le ticket original",
  "article.visibility.c3_internal_it": "C3 IT interne",
  "article.visibility.c3_deepcloud": "C3 DeepCloud",
  "description": "Description",
  "jira.jira_not_found": "Le ticket Jira n'a pas été trouvé ou vous n'y avez pas accès.",
  "jira.labels.components": "Composant(s)",
  "jira.labels.solution_versions": "Version(s) de la solution",
  "created": "Créé le",
  "author": "Auteur",
  "priority": "Priorité",
  "jira.labels.external_contacts": "Contacts externes",
  "jira.labels.affected_versions": "Version(s) concernée(s)",
  "last-modified": "Dernière modification",
  "details": "Détails",
  "type": "Type",
  "modified": "Modifié",
  "kb.edit.insert-attachment-link": "Pièce jointe",
  "comments": "Commentaires",
  "jira.comments.edited": "édité",
  "jira.comments.no_comments": "Pas encore de commentaires",
  "jira.comments.sort_newest_first": "Récents d'abord",
  "jira.comments.sort_oldest_first": "Anciens d'abord",
  "save": "Sauvegarder",
  "change-status": "Changer de statut",
  "admin.chat.status.new": "Nouveau",
  "admin.chat.status.read": "Lu",
  "admin.chat.status.in_progress": "En cours",
  "admin.chat.status.fixed": "Fixé",
  "admin.chat.status.wont_fix": "Ne sera pas réparé",
  "admin.chat.set_status_dialog.note": "Remarque (facultatif)",
  "admin.chat.admin_note": "Remarque admin",
  "admin.chat.handled_by": "Traité par {name} le {date}",
  "watchers": "Observateurs",
  "jira.errors.watchers_refresh": "La liste des observateurs n'a pas pu être mise à jour",
  "jira.no_watchers_yet": "Pas encore d'observateurs",
  "jira.watched": "Observé",
  "jira.watch": "Observer",
  "jira.filter.only_watched": "Seuls observés",
  "jira.no_attachments": "Aucune pièce jointe",
  "jira.links.title": "Liens",
  "jira.links.remote_group": "est lié à",
  "jira.links.no_links": "Aucun lien",
  "notifications.settings.title": "Notifications par e-mail",
  "notifications.settings.description": "Choisissez les événements pour lesquels vous souhaitez être averti par e-mail.",
  "notifications.settings.saved": "Paramètres mis à jour",
  "notifications.settings.event_type.kb_followed_article_changed": "Modifications des articles KB suivis",
  "notifications.settings.event_type.kb_review_approved": "Approbation d'un article KB modifié",
  "notifications.settings.event_type.kb_review_rejected": "Rejet d'un article KB modifié",
  "notifications.settings.event_type.kb_assigned": "Attribution d'un article KB",
  "notifications.settings.event_type.ticket_review_approved": "Approbation d'un ticket modifié",
  "notifications.settings.event_type.ticket_review_rejected": "Un ticket modifié jugé non pertinent",
  "notifications.settings.event_type.ticket_assigned": "Attribution d'un ticket",
  "notifications.settings.event_type.jira_followed_issue_updated": "Modifications des tickets Jira suivis",
  "tickets.state.not_relevant_ai": "Non pertinent (IA)",
  "wish_ticket.open": "Formulaire de souhaits",
  "wish_ticket.title": "Souhaits concernant l'application",
  "wish_ticket.email": "E-mail",
  "wish_ticket.customer_name": "Nom du client",
  "wish_ticket.customer_license": "Licence du client",
  "wish_ticket.section_description": "Description du souhait",
  "wish_ticket.description": "Description précise de l'exigence (situation initiale, comportement actuel vs. comportement attendu)",
  "wish_ticket.use_cases": "Quels cas d'utilisation (user stories) doivent être couverts / pris en charge?",
  "wish_ticket.frequency.label": "À quelle fréquence ce cas d'utilisation se présente-t-il? À quelle fréquence la nouvelle fonction pourrait-elle être utilisée?",
  "wish_ticket.frequency.multiple_per_day": "Fréquemment (plusieurs fois par jour)",
  "wish_ticket.frequency.multiple_per_week": "Souvent (plusieurs fois par semaine)",
  "wish_ticket.frequency.weekly_monthly": "Régulièrement (1x par semaine/mois)",
  "wish_ticket.frequency.rarely": "Rarement (1x par an, occasionnellement)",
  "wish_ticket.frequency.once": "Unique",
  "wish_ticket.target_audience": "À qui la nouvelle fonction est-elle destinée? (p. ex. comptables, collaborateurs, partenaires commerciaux, fiduciaires, etc.)",
  "wish_ticket.benefit": "Quel bénéfice global peut-on tirer de cette extension? (p. ex. simplification des processus, gain d'efficacité, automatisation, etc.)",
  "wish_ticket.discussed_with_abacus": "Le souhait a-t-il déjà été discuté avec quelqu'un chez Abacus Research AG?",
  "wish_ticket.yes": "Oui",
  "wish_ticket.no": "Non",
  "wish_ticket.additional_info": "Informations complémentaires (Avec qui cela a-t-il été discuté? Existe-t-il déjà un Jira ou une KB connu(e)?)",
  "wish_ticket.privacy": "Protection des données",
  "wish_ticket.privacy_text": "J'ai pris connaissance de la {link}.",
  "wish_ticket.privacy_link": "déclaration de protection des données",
  "wish_ticket.submit": "Envoyer le souhait",
  "wish_ticket.sent": "Votre souhait a été envoyé",
  "wish_ticket.please_select": "– veuillez sélectionner –",
  "live_status.button": "Statut",
  "live_status.title": "Statut des services",
  "live_status.all_ok": "Tous les systèmes sont opérationnels",
  "live_status.issue": "Certains services sont perturbés",
  "live_status.unreachable": "Le statut des services n'a pas pu être récupéré",
  "live_status.loading": "Chargement du statut des services…",
  "ops.cases": "Cas",
  "ops.case.create": "Saisir un cas",
  "ops.case.delete": "Supprimer le cas",
  "ops.case.delete_confirmation": "Voulez-vous vraiment supprimer ce cas ? Il disparaîtra de toutes les listes et du chat.",
  "ops.case.deleted": "Cas supprimé",
  "ops.case.saved": "Cas enregistré",
  "ops.case.load_error": "Le cas n'a pas pu être chargé.",
  "ops.case.required": "Champ obligatoire",
  "ops.case.case_no": "Numéro de cas",
  "ops.case.case_no_pending": "Attribué lors de l'enregistrement",
  "ops.case.folder": "Dossier",
  "ops.case.reported_at": "Date du signalement",
  "ops.case.affected_users": "Utilisateurs concernés",
  "ops.case.os": "OS",
  "ops.case.os_build": "Build de l'OS",
  "ops.case.version_patch": "Version / patch Abacus",
  "ops.case.applications": "Applications concernées",
  "ops.case.frequency": "Fréquence / régularité",
  "ops.case.frequency_hint": "p. ex. tous les jours à midi, toujours le 24",
  "ops.case.programs": "Programmes concernés",
  "ops.case.services": "Services concernés",
  "ops.case.required_data": "Données nécessaires à l'analyse",
  "ops.case.required_data_hint": "p. ex. heap dump et sysinfo",
  "ops.case.jira_keys": "Jiras concernés",
  "ops.case.ticket_numbers": "Tickets concernés",
  "ops.case.workarounds": "Solutions de contournement",
  "ops.case.solutions": "Solutions",
  "ops.analysis.title": "Analyses",
  "ops.analysis.add": "Ajouter une analyse",
  "ops.analysis.count": "Analyses",
  "ops.analysis.empty": "Aucune analyse saisie pour l'instant.",
  "ops.analysis.entry_title": "Analyse {0}",
  "ops.analysis.saved": "Analyse enregistrée",
  "ops.analysis.delete": "Supprimer l'analyse",
  "ops.analysis.delete_confirmation": "Voulez-vous vraiment supprimer cette analyse, fichiers compris ?",
  "ops.analysis.cpu": "CPU",
  "ops.analysis.memory": "Mémoire",
  "ops.analysis.diskspeed": "Vitesse du disque",
  "ops.analysis.abacus_services": "Services Abacus",
  "ops.analysis.procedure": "Analyse / procédure",
  "ops.analysis.log_entries": "Entrées de log",
  "ops.analysis.thread_stack": "Thread stack déterminant",
  "ops.analysis.heapdump_ref": "Référence du heap dump",
  "ops.analysis.heapdump_ref_hint": "Chemin ou lien vers le heap dump (pas de téléversement)",
  "ops.files.title": "Fichiers (thread dump, dump Prometheus, …)",
  "ops.files.hint": "Max. {0} par fichier",
  "ops.files.too_large": "« {0} » dépasse {1} et ne peut pas être téléversé. Réduisez ou divisez le fichier.",
  "servicepack_none": "Aucun pack de services",
  "ops.case.folder_root": "Niveau supérieur (aucun dossier)",
  "ops.analysis.edit": "Modifier l'analyse",
  "ops.analysis.files_after_save": "Enregistrez d'abord l'analyse pour joindre des fichiers.",
  "ops.analysis.no_details": "Aucun détail saisi.",
  "ops.analysis.file_count": "{0} fichier(s)",
  "ops.case.edit": "Modifier le cas",
  "ops.case.affected_users_hint": "Nombre"
}
